import ProductBanner from './ProductBanner'

export default ProductBanner
